module.exports = __webpack_public_path__ + "static/media/Galleria - DK Grey_Peri.ef744c07.jpg";